import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./MoreCertificates.css";

const certificateImages = [
  { id: 1, image: process.env.PUBLIC_URL + "/images/cert5.jpg.jpg", title: "Graphic Design Graduate", desc: "Completed professional graphic design program." },
  { id: 2, image: process.env.PUBLIC_URL + "/images/cert4.jpg.jpg", title: "Study Abroad Mentorship", desc: "Supporting study abroad preparation" },
  { id: 3, image: process.env.PUBLIC_URL + "/images/cert1.png.png", title: "Fundamentals of UX/UI Design", desc: "Core design principles for user experience." },
  { id: 4, image: process.env.PUBLIC_URL + "/images/cert4.png.png", title: "Front-End Developer Program", desc: "HTML, CSS, and JavaScript front-end mastery." },
  { id: 5, image: process.env.PUBLIC_URL + "/images/cert15.png.png", title: "Build Websites with APIs", desc: "Integration of REST APIs in modern web apps." },
  { id: 6, image: process.env.PUBLIC_URL + "/images/cert10.jpg.jpg", title: "AI and the Future of Work", desc: "AI innovation and industry applications." },
  { id: 7, image: process.env.PUBLIC_URL + "/images/cert8.jpg.jpg", title: "Building Diverse Teams", desc: "Inclusive teamwork and communication." },
  { id: 8, image: process.env.PUBLIC_URL + "/images/cert18.jpg.jpg", title: "Research (CUAF)", desc: "Certifies completion of a full research course and acquired skills." },
  { id: 9, image: process.env.PUBLIC_URL + "/images/cert14.png.png", title: "Advanced Web Design", desc: "Advanced responsive and modern web design." },
  { id: 10, image: process.env.PUBLIC_URL + "/images/cert13.jpg.jpg", title: "Python", desc: "Innovative design and problem-solving." },
  { id: 11, image: process.env.PUBLIC_URL + "/images/cert17.jpg.png", title: "AI Technology", desc: "AI and Technology Webinar." },
  { id: 12, image: process.env.PUBLIC_URL + "/images/cert16.jpg.png", title: "Women Ascension Mentorship", desc: "Engaged in leadership and community empowerment " },
];


const MoreCertificates = () => {
  const [selected, setSelected] = useState(null);

  return (
    <section className="more-certificates">
      <h2>
        My <span>Certificates</span>
      </h2>

      <div className="cert-grid">
        {certificateImages.map((cert) => (
          <div key={cert.id} className="cert-card" onClick={() => setSelected(cert)}>
            <img src={cert.image} alt={cert.title} />
            <h3>{cert.title}</h3>
            <p>{cert.desc}</p>
          </div>
        ))}
      </div>

      {selected && (
        <div className="popup" onClick={() => setSelected(null)}>
          <div className="popup-content" onClick={(e) => e.stopPropagation()}>
            <button className="close-btn" onClick={() => setSelected(null)}>×</button>
            <img src={selected.image} alt={selected.title} />
            <h3>{selected.title}</h3>
            <p>{selected.desc}</p>
          </div>
        </div>
      )}

      <div className="back-btn-container">
        <Link to="/certifications" className="back-btn">← Back to Certifications</Link>
      </div>
    </section>
  );
};

export default MoreCertificates;
